/*
 * Copyright (c) 2023 Puratos. All rights reserved.
 */

import React from 'react';
import {AddToCartButton} from "../finder/AddToCartButton";
import {GTMContextProvider} from "../../../analytics/ga4/utils/GTMContext";
import { useSelector} from "react-redux";
import { getLanguageIso } from '../../../selectors/generic';
import { selectMyPuratosAccountEmail, selectUserId } from "../../../selectors/auth";
import {addProductClickEvent} from "../../../utils/customEventHandler";
import {GA4InteractionType} from "../../../analytics/ga4/types/interaction";
import {getCurrencyCode} from "../../../selectors/cart";
import { googleEvents } from '../../../utils/googleEvents';
import { isLoggedIn } from '../../../data/user.model';
import { GA4LoginType } from '../../../analytics/ga4/types/login';
import { GA4PageType } from '../../../analytics/ga4/types/page';
import { productEventParseSelect } from '../../../analytics/ga4/parsers/item';

export default function RecipeListRow({row, showPercentageValues, showAddToCart, translate, position}) {

    const userId = useSelector(selectUserId);
    const currency = useSelector(getCurrencyCode);
    const productClickData = row?.productDetails?.variationsList.map(item => {return {...item, aemProdName: row.ingredientLabel}});
    const userEmail = useSelector(selectMyPuratosAccountEmail);
    const detailsAvailable = row.productDetails || row.productReference;

    const addEvent = () => {
        addProductClickEvent(
            productClickData,
            GA4InteractionType.recipe,
            true,
            userId,
            currency,
            position
        );
        googleEvents.selectItem({
            user_id: userId,
            page_language: getLanguageIso(),
            email_address: isLoggedIn() ? userEmail : '',
            login_status: userId ? GA4LoginType.LOGGED_IN : GA4LoginType.GUEST,
            website_section: GA4PageType.recipe,
            items: productEventParseSelect(productClickData, currency, GA4InteractionType.recipe)
        });
    }

    return (
        <React.Fragment>

            {row && row.ingredientLabel && <tr>
                <td className={`p-table-text p-relative`}>
                    {row.link ? <a className={"p-text-color-red"} href={row.ingredientProductLink} onClick={addEvent}
                                   onMouseDown={(e) => e.button === 1 && addEvent()}>
                        {row.ingredientLabel} {row.addRemark}
                    </a> : <>{row.ingredientLabel} {row.addRemark}</>}
                    {showAddToCart && row.link && detailsAvailable &&
                    <GTMContextProvider type={GA4InteractionType.recipe}>
                        <AddToCartButton product={row.productDetails || row.productReference} isNewPdp={!!row.productReference} padding inverted small
                                         label={translate("Add to cart")} absolute={true} useHasPrice={false}/>
                    </GTMContextProvider>}
                </td>
                <td className="text-right p-table-text">
                    {row.ingredientUnits}
                </td>
                {showPercentageValues && <td className="text-right p-table-text">
                    {row.ingredientPercentage}
                </td>}
            </tr>}

        </React.Fragment>
    );

}
